/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getTndAccount = /* GraphQL */ `
  query GetTndAccount($id: ID!) {
    getTndAccount(id: $id) {
      id
      enabled
      location
      description
      loginId
      loginPassword
      apiKey
      users
    }
  }
`;
export const listTndAccounts = /* GraphQL */ `
  query ListTndAccounts(
    $filter: ModelTndAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTndAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        enabled
        location
        description
        loginId
        loginPassword
        apiKey
        users
      }
      nextToken
    }
  }
`;
export const getSensorName = /* GraphQL */ `
  query GetSensorName($serial: String!) {
    getSensorName(serial: $serial) {
      serial
      name
      ch1
      ch2
    }
  }
`;
export const listSensorNames = /* GraphQL */ `
  query ListSensorNames(
    $serial: String
    $filter: ModelSensorNameFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSensorNames(
      serial: $serial
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        serial
        name
        ch1
        ch2
      }
      nextToken
    }
  }
`;
export const getSensorDayReading = /* GraphQL */ `
  query GetSensorDayReading($serial: String!, $localDate: String!) {
    getSensorDayReading(serial: $serial, localDate: $localDate) {
      serial
      localDate
      tndAccountLoginId
      name
      utcOffsetMinutes
      readings {
        dataId
        unixtime
        reading
      }
      channel2Name
      channel2Readings {
        dataId
        unixtime
        reading
      }
    }
  }
`;
export const listSensorDayReadings = /* GraphQL */ `
  query ListSensorDayReadings(
    $serial: String
    $localDate: ModelStringKeyConditionInput
    $filter: ModelSensorDayReadingFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSensorDayReadings(
      serial: $serial
      localDate: $localDate
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        serial
        localDate
        tndAccountLoginId
        name
        utcOffsetMinutes
        readings {
          dataId
          unixtime
          reading
        }
        channel2Name
        channel2Readings {
          dataId
          unixtime
          reading
        }
      }
      nextToken
    }
  }
`;
export const getLastSensorUnixTime = /* GraphQL */ `
  query GetLastSensorUnixTime($serial: String!) {
    getLastSensorUnixTime(serial: $serial) {
      serial
      unixtime
      name
      tndAccountLoginId
      lastCheckUnixtime
    }
  }
`;
export const listLastSensorUnixTimes = /* GraphQL */ `
  query ListLastSensorUnixTimes(
    $serial: String
    $filter: ModelLastSensorUnixTimeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLastSensorUnixTimes(
      serial: $serial
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        serial
        unixtime
        name
        tndAccountLoginId
        lastCheckUnixtime
      }
      nextToken
    }
  }
`;
export const getSensorCheckoutControl = /* GraphQL */ `
  query GetSensorCheckoutControl($serial: String!) {
    getSensorCheckoutControl(serial: $serial) {
      serial
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const listSensorCheckoutControls = /* GraphQL */ `
  query ListSensorCheckoutControls(
    $serial: String
    $filter: ModelSensorCheckoutControlFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSensorCheckoutControls(
      serial: $serial
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        serial
        tndAccountLoginId
        name
        notes
        checkoutUnixtime
        checkinUnixtime
        checkoutType
        utcOffsetMinutes
        ddbDescription
        ddbCheckoutDate
        ddbCheckinDate
      }
      nextToken
    }
  }
`;
export const getSensorCheckoutRecord = /* GraphQL */ `
  query GetSensorCheckoutRecord($serial: String!, $localDate: String!) {
    getSensorCheckoutRecord(serial: $serial, localDate: $localDate) {
      serial
      localDate
      tndAccountLoginId
      name
      notes
      checkoutUnixtime
      checkinUnixtime
      checkoutType
      utcOffsetMinutes
      ddbDescription
      ddbCheckoutDate
      ddbCheckinDate
    }
  }
`;
export const listSensorCheckoutRecords = /* GraphQL */ `
  query ListSensorCheckoutRecords(
    $serial: String
    $localDate: ModelStringKeyConditionInput
    $filter: ModelSensorCheckoutRecordFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSensorCheckoutRecords(
      serial: $serial
      localDate: $localDate
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        serial
        localDate
        tndAccountLoginId
        name
        notes
        checkoutUnixtime
        checkinUnixtime
        checkoutType
        utcOffsetMinutes
        ddbDescription
        ddbCheckoutDate
        ddbCheckinDate
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($username: String!) {
    getUser(username: $username) {
      username
      email
      name
      city
      company
      department
      post
      phone
      privileges
      tndAccountLoginIds
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $username: String
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsers(
      username: $username
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        username
        email
        name
        city
        company
        department
        post
        phone
        privileges
        tndAccountLoginIds
      }
      nextToken
    }
  }
`;
export const listSensorDayReadingsByAccountByDate = /* GraphQL */ `
  query ListSensorDayReadingsByAccountByDate(
    $tndAccountLoginId: String
    $localDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSensorDayReadingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSensorDayReadingsByAccountByDate(
      tndAccountLoginId: $tndAccountLoginId
      localDate: $localDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        serial
        localDate
        tndAccountLoginId
        name
        utcOffsetMinutes
        readings {
          dataId
          unixtime
          reading
        }
        channel2Name
        channel2Readings {
          dataId
          unixtime
          reading
        }
      }
      nextToken
    }
  }
`;
export const listSensorCheckoutRecordsByAccountByDate = /* GraphQL */ `
  query ListSensorCheckoutRecordsByAccountByDate(
    $tndAccountLoginId: String
    $localDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSensorCheckoutRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSensorCheckoutRecordsByAccountByDate(
      tndAccountLoginId: $tndAccountLoginId
      localDate: $localDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        serial
        localDate
        tndAccountLoginId
        name
        notes
        checkoutUnixtime
        checkinUnixtime
        checkoutType
        utcOffsetMinutes
        ddbDescription
        ddbCheckoutDate
        ddbCheckinDate
      }
      nextToken
    }
  }
`;
